<template>
  <div>
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Informacje zgłoszeniowe</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-form @submit.prevent="updateRunner"novalidate>
        <resp-header color="tertiary">
          <template slot="left">
            BIEGOWE
          </template>
          <span slot="right">
            Wypełnij poniższe dane aby trener mógł sporządzić optymalny dla Ciebie plan treningowy
          </span>
        </resp-header>
        <v-layout row wrap justify-center class="grid-gap my-4">
          <v-flex xs12 sm12 md5 lg4>
              <runner-step-field
                :editable="updateMode"
                label="Staż biegowy*"
                v-model="form.training_practice"
                :objValue="runner.training_practice"
                :formErrors="formErrors"
                :field="'training_practice'"></runner-step-field>
              <runner-step-field
                :editable="updateMode"
                label="Tygodniowy kilometraż*"
                v-model="form.weekly_mileage"
                :objValue="runner.weekly_mileage"
                :formErrors="formErrors"
                :field="'weekly_mileage'"></runner-step-field>
              <runner-step-field
                :class="{bigger: updateMode}"
                :editable="updateMode"
                label="Aktualny cel główny*"
                v-model="form.main_goal"
                :objValue="runner.main_goal"
                :formErrors="formErrors"
                :field="'main_goal'">

                  <template slot-scope="{ error, errorMessages, label }">
                    <v-textarea
                                  :label="label"
                                  v-model="form.main_goal"
                                  :error="error"
                                  :error-messages="errorMessages"
                                  rows="3"
                                  auto-grow
                    />
                  </template>
              </runner-step-field>
              <runner-step-field
                :class="{bigger: updateMode}"
                :editable="updateMode"
                label="Aktualne cele dodatkowe"
                v-model="form.additional_goal"
                :objValue="runner.additional_goal"
                :formErrors="formErrors"
                :field="'additional_goal'">
                  <template slot-scope="{ error, errorMessages, label }">
                    <v-textarea
                                  :label="label"
                                  v-model="form.additional_goal"
                                  :error="error"
                                  :error-messages="errorMessages"
                                  rows="3"
                                  auto-grow
                    />
                  </template>
              </runner-step-field>
          </v-flex>

          <v-flex xs12 sm12 md5 lg4>
              <runner-step-field
                :editable="updateMode"
                label="Ilość treningów*"
                description='Ilość dni treningowych w tygodniu'
                v-model="form.training_days_number"
                :objValue="runner.training_days_number"
                :formErrors="formErrors"
                :field="'training_days_number'"></runner-step-field>

              <runner-step-field
                :editable="updateMode"
                label="Dni treningowe*"
                description="Proponowane dni treningowe w tygodniu"
                v-model="form.training_days"
                :objValue="runner.training_days"
                :formErrors="formErrors"
                :field="'training_days'">
                  <template slot-scope="{ error, errorMessages, label}">
                    <v-select
                      v-model="form.training_days"
                      :menu-props="{ maxHeight: '400' }"
                      :error="error"
                      :label="label"
                      :error-messages="errorMessages"
                      multiple
                      :items="['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela']">
                    </v-select>
                  </template>
              </runner-step-field>

              <runner-step-field
                :editable="updateMode"
                label="Czas sesji treningowej"
                description="Najdłuższy czas jednej sesji treningowej"
                v-model="form.training_session_length"
                :objValue="runner.training_session_length"
                :formErrors="formErrors"
                :field="'training_session_length'"></runner-step-field>

              <runner-step-field
                :editable="updateMode"
                label="Przeciwwskazania*"
                description="Przeciwwskazania do uprawniania sportu"
                v-model="form.contraindications"
                :objValue="runner.contraindications"
                :formErrors="formErrors"
                :field="'contraindications'"></runner-step-field>
          </v-flex>
        </v-layout>
        <resp-header color="tertiary">
          <template slot="left">
            REKORDY
          </template>
          <span slot="right">
            Dodaj swoje rekordy życiowe dla wybranych przez siebie dystansów
          </span>
        </resp-header>
        <v-layout row wrap justify-center class="grid-gap my-4">
          <v-flex
            xs12
            sm12
            md12
            lg10
            xl8>
              <records></records>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-end>
          <v-flex class="step-buttons">
            <v-btn dark :to="{name: 'runner-application-data-trainer', params: {id: $route.params.id}}" class="mr-4" color="tertiary">Wstecz</v-btn>
            <v-btn v-if="updateMode" type="submit" color="primary">Dalej</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {updateRunnerData1, getRunnerData1} from './api'
import * as types from '@/store/mutation-types'
import store from '@/store'
import { mapGetters } from 'vuex'
import RunnerStepField from './RunnerStepField'
import Records from '@/results/Records'
import RespHeader from '@/utils/RespHeader'

export default {
  components: {RunnerStepField, Records, RespHeader},
  validators: {
  },
  data () {
    return {
      updateMode: true,
      formErrors: {},
      availableTrainers: [],
      runner: {},
      form: {}
    }
  },
  computed: {
    ...mapGetters(['allPackagesFullOptions', 'allTrainersFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])
  },
  beforeRouteEnter (to, from, next) {
    if (parseInt(to.params.id) === store.getters.authUser.id) {
      next()
    } else {
      next({name: 'login'})
    }
  },
  mounted () {
    getRunnerData1(this.$route.params.id).then((data) => {
      this.runner = data
      this.form = {...data}
      this.validation.reset()
    })
  },
  created () {
    this.p1 = this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
    this.p2 = this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  watch: {
    'form.package': function (value, oldVal) {
      Promise.all([this.p1, this.p2]).then(() => {
        this.packageChange(value)
      })
    }
  },
  methods: {
    packageChange (value) {
      let packageData = this.getPackageById(value)
      if (packageData && packageData.trainer) {
        let trainer = this.getTrainerById(packageData.trainer)
        if (trainer) {
          this.availableTrainers = [trainer]
          this.form.trainer = trainer.id
        } else {
          this.availableTrainers = this.allTrainersFullOptions
        }
      } else {
        this.availableTrainers = this.allTrainersFullOptions
      }
    },
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData1(parseInt(this.$route.params.id), this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-application-data-updated', data)
            this.$router.push({name: 'runner-application-data-second', params: {id: this.$route.params.id}})
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
div.v-list__tile__action div.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerApplicationDataFirst.vue